/* eslint-disable no-undef */

import { isIpadApp, isMobileApp } from './browserutils'
import { appCache } from '../context/appCache'

/* this is disabled for no-undef because the global native instance are used and it has definition within native part */
export const NativeInterfaceHandler = (handler, data) => {
  if (isMobileApp() || isIpadApp()) {
    let parameters = {}
    switch (handler) {
      case 'AlertManagement':
        parameters = {
          payeeID: data.payeeID,
          name: data.nickName || data.displayName,
          productCode: data.productCode,
          subProductCode: data.subProductCode
        }

        break
      case 'SSOBlackNight':
        parameters = data
        break
      case 'SendMoney':
        parameters = ''
        break
      case 'ConfigureHeader':
        parameters = data
        break
      case 'TUXIntegration':
        parameters = ''
        break
      case 'TransmitToken':
        parameters = ''
        break
      case 'ScreenCapture':
        parameters = ''
        break
      case 'TimeOut':
        parameters = { timeOutCode: data }
        break
      case 'PopUpHandler':
        parameters = { isDisplay: data }
        break
      case 'ViewEBill':
        parameters = data
        break
      case 'EBillEnrollTerms':
        parameters = data
        break
      case 'ReturnToChecklist':
        parameters = { isAutopaySuccess: data }
        break
      case 'gotomarketplace':
        parameters = data
        break
      case 'SessionSurveyFlag':
        parameters = { prevSessionSurvey: data }
        break
      case 'StopCheck':
        parameters = data
        break
      default:
        parameters = data
    }

    if (
      typeof window !== 'undefined' &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.iOSMessageHandler
    ) {
      window.webkit.messageHandlers.iOSMessageHandler.postMessage({
        handler,
        data: parameters
      })
    } else if (
      typeof window !== 'undefined' &&
      typeof AndroidReactInterface !== 'undefined' &&
      AndroidReactInterface &&
      AndroidReactInterface.connectWithNativeInterface !== 'undefined'
    ) {
      AndroidReactInterface.connectWithNativeInterface(
        JSON.stringify({
          handler,
          data: parameters
        })
      )
    } else if (handler === 'TransmitToken') {
      if (
        typeof window !== 'undefined' &&
        window &&
        typeof window.ReactInterfaceHandler !== 'undefined'
      )
        ReactInterfaceHandler(handler, '{}')
    }
  } else if (handler === 'TransmitToken') {
    if (
      typeof window !== 'undefined' &&
      window &&
      typeof window.ReactInterfaceHandler !== 'undefined'
    )
      ReactInterfaceHandler(handler, '{}')
  }
}

export const configureNativeHeader = (
  page,
  backarrowshow,
  navigateFrom = false,
  navigateTo = false,
  isExitOnBackAction = false,
  data = null
) => {
  let config
  switch (page) {
    case 'dashboard':
      config = {
        isBlueToolBar: false,
        showBackButton: backarrowshow,
        navigateFrom,
        navigateTo,
        isNavigateTo: !!navigateTo,
        isBackNavigationOnClose: false,
        isExitOnBackAction: false,
        isDashBoard: true
      }

      break
    case 'termsandcondition':
      config = {
        isBlueToolBar: false,
        showBackButton: backarrowshow,
        navigateFrom,
        navigateTo,
        isNavigateTo: !!navigateTo,
        isBackNavigationOnClose: true,
        isExitOnBackAction: false,
        isDashBoard: false
      }

      break
    case 'findabilldashboard':
      config = {
        isBlueToolBar: false,
        showBackButton: backarrowshow,
        navigateFrom,
        navigateTo,
        isNavigateTo: !!navigateTo,
        isBackNavigationOnClose: false,
        isExitOnBackAction,
        isDashBoard: false,
        data
      }

      break
    case 'firsttimesharedaccess':
      config = {
        isBlueToolBar: false,
        showBackButton: backarrowshow,
        navigateFrom,
        navigateTo,
        isNavigateTo: !!navigateTo,
        isBackNavigationOnClose: false,
        isExitOnBackAction: true,
        isDashBoard: false,
        page
      }
      break
    default:
      config = {
        isBlueToolBar: false,
        showBackButton: backarrowshow,
        navigateFrom,
        navigateTo,
        isNavigateTo: !!navigateTo,
        isBackNavigationOnClose: false,
        isExitOnBackAction: false,
        isDashBoard: false
      }

      break
  }
  appCache({ ...appCache(), backActionData: config })
  NativeInterfaceHandler('ConfigureHeader', config)
}
